"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AppErrorBoundaryWithoutRouter = exports.AppErrorContext = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _error = _interopRequireDefault(require("../../components/_error"));

var _errors = require("../../errors");

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const AppErrorContext = /*#__PURE__*/_react.default.createContext();

exports.AppErrorContext = AppErrorContext;
const isProduction = process.env.NODE_ENV === 'production';
/**
 * @private
 */

class AppErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: props.error
    };
    this.onGetPropsError = this.onGetPropsError.bind(this);
  }

  componentDidMount() {
    const {
      history
    } = this.props;

    if (history) {
      this.unlisten = history.listen(() => {
        // Clear error state on location change. This is used when a user
        // clicks the back button after encountering a page with an error.
        if (this.state.error) {
          this.setState({
            error: undefined
          });
        }
      });
    }
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  } // React's client side error boundaries


  static getDerivedStateFromError(err) {
    // Update state so the next render will show the fallback UI
    return {
      error: {
        message: err.toString(),
        stack: err.stack
      }
    };
  }

  onGetPropsError(err) {
    if (err instanceof _errors.HTTPError) {
      this.setState({
        error: {
          message: err.message,
          status: err.status,
          stack: err.stack
        }
      });
    } else {
      this.setState({
        error: {
          message: err ? err.toString() : '',
          status: 500,
          stack: err ? err.stack : ''
        }
      });
    }
  }

  render() {
    const {
      children
    } = this.props;
    const error = this.state.error ? {
      message: this.state.error.message,
      status: this.state.error.status,
      stack: isProduction ? undefined : this.state.error.stack
    } : undefined;
    return /*#__PURE__*/_react.default.createElement(AppErrorContext.Provider, {
      value: {
        onGetPropsError: this.onGetPropsError
      }
    }, error ? /*#__PURE__*/_react.default.createElement(_error.default, error) : children);
  }

}

exports.AppErrorBoundaryWithoutRouter = AppErrorBoundary;
AppErrorBoundary.propTypes = {
  children: _propTypes.default.node,
  error: _propTypes.default.shape({
    message: _propTypes.default.string.isRequired,
    status: _propTypes.default.number.isRequired
  }),
  history: _propTypes.default.object
};

var _default = (0, _reactRouterDom.withRouter)(AppErrorBoundary);

exports.default = _default;